import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@unico-people/shared/utils/environments';

interface Token {
  token: string;
  status: number;
  error: string;
}

export interface CodeChallenge {
  raw: string;
  method: string;
}

interface Authorize {
  email: string;
  error: string;
  id: string;
  name: string;
  organization: string;
  status: number;
}

@Injectable({
  providedIn: 'root'
})
export class DataAccessCallbackService {
  private readonly url: string = environment.url_admission_api;

  constructor(private http: HttpClient) {}

  /**
   * Takes callback code and returns a token
   * @param code a token that Identity pass via a callback URL
   * @returns an object with a valid token
   */
  getToken(code: string, redirectTarget?: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        redirectURI: this.getRedirectUri(redirectTarget) || environment.redirect_uri_admission,
        code: code
      }),
      withCredentials: true
    };

    return this.http.get<Token>(`${this.url}/authorize/code`, httpOptions);
  }

  /**
   * Takes the token and returns user infos and organization id
   * @param token a valid token
   * @returns an object with user infos and organization id
   */
  getAuthorization(token: string) {
    return this.http.get<any>(`${this.url}/authorize`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
      observe: 'response',
      withCredentials: true
    });
  }

  /**
   * Takes the code challenge for pkce authentication flow
   * @returns an object with code challenge
   */
  getCodeChallenge() {
    const httpOptions = {
      withCredentials: true
    };
    return this.http.get<CodeChallenge>(`${this.url}/authorize/challenge`, httpOptions);
  }

   /**
   * Get redirect url
   * @param slug url target
   * @returns redirect uri
   */
  getRedirectUri(slug: string): string {
    const uriPaths = {
      benefits : () => environment.redirect_uri_benefits,
      eligibility: () => environment.redirect_uri_benefits + '/eligibility',
      productivity: () => environment.redirect_uri_benefits + '/productivity',
      ongoing: () => environment.redirect_uri_ongoing
    }

    return uriPaths[slug]();
  }
}
